module.exports = __webpack_public_path__ + "static/media/ilo_contact.74ea2728.png";